export default __webpack_public_path__ + "static/media/picHungLuong.101b2c62.png";